import { FC } from 'react';

import AddTradingOfferResumeSection from './AddTradingOfferResumeSection';
import AddTradingOfferDataSection from './AddTradingOfferDataSection';

const AddTradingOfferPageBody: FC = () => (
  <div className="nk-block">
    <div className="row">
      <AddTradingOfferDataSection />

      <AddTradingOfferResumeSection />
    </div>
  </div>
);

export default AddTradingOfferPageBody;
